import React from 'react';
import TransitionDots from '../shared/transition_dots';

const Button = ({ buttonClass, text, colour, onClickHandler, isTransitioning, disabled }) => {
  return (
    <button
      className={buttonClass}
      type="button"
      style={colour ? { backgroundColor: colour } : null}
      onClick={onClickHandler}
      disabled={disabled}
    >
      {isTransitioning && <TransitionDots />}
      {!isTransitioning && text}
    </button>
  );
};

export default Button;
